// Ported from src/views/auth/auth-callbacks/GoogleOAuth2Client.js — same env
// vars/endpoints (the backend, not this client, holds the actual client
// secret), restructured to fit v2's service conventions. The OAuth redirect
// lands back on src/views/auth/auth-callbacks/OAuth2StorageProviderCallback.vue
// (a shared, app-wide route — not part of the v2/legacy view split), which
// uses its own copy of this class to complete the token exchange.
const { VITE_G_AUTH_ENDPOINT, VITE_G_AUTH_TOKEN_ENDPOINT } = import.meta.env;

export default class GoogleOAuth2Client {
  static titleName = "Google Drive";
  #authEndpoint = VITE_G_AUTH_ENDPOINT;
  #tokenEndpoint = VITE_G_AUTH_TOKEN_ENDPOINT;

  async getAuthWithRedirect(transitedState) {
    const backendUrl = new URL(this.#authEndpoint);
    backendUrl.searchParams.set("state", window.btoa(JSON.stringify(transitedState)));

    const response = await fetch(backendUrl.href, {
      headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
    });
    const data = await response.json();
    window.location.href = data.auth_url;
  }

  async callbackHandler(query = {}) {
    const { state, code } = query;
    const params = new URLSearchParams({ code, state });
    const response = await fetch(this.#tokenEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      body: params.toString(),
    });
    const data = await response.json();
    if (data.access_token) return { access_token: data.access_token, refresh_token: data.refresh_token };
    if (data.error) throw new Error(`${data.error}:${data.error_description ?? ""}`);
  }
}
